// ─── TanStack Query key factory for chat features ─────────────────────────────

export const chatKeys = {
  all: ['chat'] as const,
  sessions: () => [...chatKeys.all, 'sessions'] as const,
  sessionsList: (tenantSlug?: string) =>
    [...chatKeys.sessions(), 'list', tenantSlug ?? 'all'] as const,
  session: (id: string) => [...chatKeys.sessions(), 'detail', id] as const,
  messages: (sessionId: string) => [...chatKeys.session(sessionId), 'messages'] as const,
};
